import '../styles/messages.css'
import FaqComponent from '../Components/UI/FaqComponent'
import { useState } from 'react'
import { MiddleBodyBot } from '../Services/imagesRequest'
import { chatbotName } from '../Chatbot/config'

const StoryComponent = ({ payload }) => {
  const { answerFaq, faq, resultId, queryId } = payload
  const [expandedFaqResultId, setExpandedFaqResultId] = useState(null)

  const toggleFaq = (resultId) => {
    setExpandedFaqResultId((prevId) => (prevId === resultId ? null : resultId))
  }

  return (
    <div className="chat-message-container">
      {answerFaq?.answer && (
        <div className="story-message-text" dangerouslySetInnerHTML={{ __html: answerFaq.answer }} />
      )}
      {faq && <FaqComponent faq={faq} expandedFaqResultId={expandedFaqResultId} toggleFaq={toggleFaq}
        resultId={resultId} queryId={queryId} />}
      {<img src={MiddleBodyBot} alt={`Imagem avatar ${chatbotName}`} className="Bot-image" />}
    </div>
  )
}

export default StoryComponent